import React from 'react';
import { Alert, Box } from '@mui/material';
import type { Technika } from '../api/JsdhNotifikaceService/generated/models/Technika';
import { DUVOD_LABELS } from '../api/JsdhNotifikaceService/generated/models/DostupnostTechnika';

interface Props {
    aktivniTechnika: Technika[];
    selectedTechnikaIds: number[];
}

/** HO-3: varovani pri rucnim povolani odhlaseneho vozidla. Povolani NEBLOKUJE. */
const NedostupnaTechnikaWarning: React.FC<Props> = ({ aktivniTechnika, selectedTechnikaIds }) => {
    const nedostupneVybrane = aktivniTechnika.filter(
        t => selectedTechnikaIds.includes(t.id) && t.dostupnostStav === 'NEDOSTUPNA'
    );
    if (nedostupneVybrane.length === 0) return null;
    return (
        <Alert severity="warning" sx={{ mt: 1 }}>
            {nedostupneVybrane.map(t => (
                <Box key={t.id}>
                    <strong>{t.volaciZnak}</strong> je odhlášená
                    {t.dostupnostDuvod ? ` (${DUVOD_LABELS[t.dostupnostDuvod]})` : ''}
                    {t.dostupnostDo
                        ? ` do ${new Date(t.dostupnostDo).toLocaleString('cs-CZ')}`
                        : ' do odvolání'}
                    . Povolání není blokováno — potvrďte vědomě.
                </Box>
            ))}
        </Alert>
    );
};

export default NedostupnaTechnikaWarning;
